var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('similar-jobs-preview',{staticClass:"is-full-width",attrs:{"collection-name":"jobSearchCollection","text":"No such similar jobs are available at the moment"}})}
var staticRenderFns = []

export { render, staticRenderFns }